<template>
  <TransitionRoot as="template" :show="!!props.open">
    <Dialog as="div" class="relative z-20" @close="close">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </TransitionChild>

      <div class="fixed inset-0">
        <div
          class="flex min-h-full items-center justify-center p-4 sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative rounded-md bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg sm:p-6"
            >
              <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  class="rounded-sm bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  @click="close"
                >
                  <span class="sr-only">Close</span>
                  <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div class="sm:flex sm:items-start w-full">
                <div class="mt-3 sm:mt-0 sm:text-left w-full">
                  <DialogTitle
                    as="h3"
                    class="text-base font-semibold leading-6 text-gray-900"
                    >Assign QR Code
                  </DialogTitle>
                  <div class="mt-2">
                    <LocationDropdown
                      disable-tenants
                      disable-groups
                      selector-style="dropdown"
                      :model-value="space"
                      @update:model-value="handleSpaceSelected"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <primary-button
                  class="w-full sm:w-auto sm:ml-3"
                  label="Assign"
                  loading-label="Assigning"
                  @click="assign"
                  :loading="props.loading"
                />
                <secondary-button
                  label="Cancel"
                  class="mt-3 sm:mt-0"
                  @click="close"
                />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton.vue";
import SecondaryButton from "@/Tailwind/Components/Buttons/SecondaryButton.vue";
import LocationDropdown from "@/Tailwind/Components/Input/LocationDropdown.vue";

const emit = defineEmits(["assign", "close"]);
const props = defineProps({
  open: Boolean,
  loading: Boolean,
});

watch(
  () => props.open,
  () => {
    space.value = {};
  }
);

const space = ref();

function handleSpaceSelected(value) {
  space.value = value;
}

function assign() {
  emit("assign", space.value.id);
}

function close() {
  emit("close");
}
</script>
